export default class FieldValidator {
    static notBlank(value: string): boolean {
        return /\S/.test(value);
    }

    static email(value: string): boolean {
        return !FieldValidator.notBlank(value) || /^.+@.+\..+$/.test(value);
    }

    static phone(value: string): boolean {
        return (
            !FieldValidator.notBlank(value) ||
            /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/.test(value)
        );
    }

    static number(value: string): boolean {
        if (!FieldValidator.notBlank(value)) return true;

        const cleaned = value.replace(/[^0-9.,]/g, '');
        const parsed = parseFloat(cleaned);

        return /^[+-]?[0-9.,]+$/.test(value) && !isNaN(parsed);
    }
}